<template>
	<div v-loading="loading" style="position: relative;flex: 1;height: 100%;overflow: hidden;">
		<div style="width: 100%;height: 100%;padding: 15px;overflow-x: hidden;overflow-y: auto;">
			<!-- 顶部查询 -->
			<div style="border: 1px solid #ccc;background: #f7f7f7;border-radius: 5px;">
				<div class="base_inquire" style="padding: 20px 30px 5px;border-bottom: 1px solid #ccc;">
					<div class="b_item">
						<span class="b_label">区域：</span>
						<VDistpicker @province="handleSearchProvinceSelect" @city="handleSearchCitySelect"
							@area="handleSearchAreaSelect"></VDistpicker>
					</div>
					<div class="b_item">
						<span class="b_label">产品：</span>
						<el-select v-model="search_product" class="b_inp" placeholder="请选择" :clearable="true">
							<el-option v-for="v in authProduct" :key="v.id" :value="v.id" :label="v.name"></el-option>
						</el-select>
					</div>
					<div class="b_item">
						<span class="b_label">开始时间：</span>
						<el-date-picker v-model="search_startTime" :editable="false" placeholder="开始时间" type="datetime"
							value-format="yyyy-MM-dd HH:mm:ss" @change="handleSearchStartTimeClick">
						</el-date-picker>
					</div>

					<div class="b_item">
						<span class="b_label">结束时间：</span>
						<el-date-picker v-model="search_endTime" :editable="false" placeholder="结束时间" type="datetime"
							value-format="yyyy-MM-dd HH:mm:ss" @change="handleSearchEndTimeClick">
						</el-date-picker>
					</div>
				</div>
				<div class="base_inquire" style="padding: 20px 30px 5px;">
					<div class="b_item">
						<span class="b_label">医院名称：</span>
						<el-autocomplete class="b_inp" v-model="search_name" :fetch-suggestions="querySearchName"
							placeholder="请输入医院名称"></el-autocomplete>
					</div>
					<div v-if="search_type == 1" class="b_item">
						<span class="b_label">支付类型：</span>
						<el-select v-model="search_payType" class="b_inp" placeholder="请选择" :clearable="true">
							<el-option v-for="v in payType" :key="v.type" :value="v.type" :label="v.name"></el-option>
						</el-select>
					</div>
					<el-button type="primary" @click="handleSearchClick">查询</el-button>
				</div>
			</div>
			<!-- 顶部查询 end -->

			<!-- 总计 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div style="float: left;color: #222;line-height: 36px;">总计：已收入<span
						style="margin: 0 5px;font-size: 28px;color: #409EFF;">{{ total }}</span>笔。</div>
				<div style="float: right;">
					<el-button type="primary" @click="exportExcel">下载：excel格式</el-button>
				</div>
			</div>
			<!-- 总计 end -->

			<!-- 查询类型 -->
			<div class="base_inquire" style="margin-top: 20px;">
				<div class="b_item">
					<span class="b_label">查询类型：</span>
					<el-select v-model="search_type" class="b_inp" @change="handleSearchTypeChange">
						<el-option value="1" label="充值"></el-option>
						<el-option value="2" label="消费"></el-option>
					</el-select>
				</div>
			</div>
			<!-- 查询类型 end -->

			<!-- 状态 -->
			<ul class="base_table_status">
				<li v-for="v in show_type" :key="v.category" :class="{b_item_on: show_type_active == v.category}"
					class="b_item" @click="handleShowTypeClick(v.category)">{{ v.name }}</li>
			</ul>
			<!-- 状态 end -->

			<!-- 表格 -->
			<div class="base_table">
				<el-table :data="tableData" style="width: 100%">
					<el-table-column prop="code" :label="search_type == 1 ? '编码' : '账号'">
					</el-table-column>
					<el-table-column prop="name" :label="search_type == 1 ? '医院名称' : '被操作人'">
					</el-table-column>
					<el-table-column prop="num" label="次数">
					</el-table-column>
					<el-table-column prop="productName" label="产品">
					</el-table-column>
					<el-table-column v-if="search_type == 1 && authInfo.ucategory == 1" prop="counts" label="购买次数">
					</el-table-column>
					<el-table-column v-if="search_type == 1" prop="payName" label="支付类型">
					</el-table-column>
					<el-table-column prop="actionName" label="操作类型">
					</el-table-column>
					<el-table-column prop="operator" label="操作人">
					</el-table-column>
					<el-table-column prop="operatorForm" label="操作机构">
					</el-table-column>
					<el-table-column v-if="search_type == 1" prop="remark" label="备注">
					</el-table-column>
					<el-table-column prop="creatTime" label="创建时间">
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->

			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination layout="total, prev, pager, next, jumper" next-text="下一页" :total="total"
						:current-page="currentPage" @current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
	</div>
</template>

<script>
	import Api from '../../../../api/index.js'
	import {
		mapState
	} from 'vuex'
	import BaseMethods from "../../../../assets/js/base.js"

	export default {
		mounted() {
			this.setShowType();
			this.getList();
		},
		beforeDestroy() {
			this.queryInterval && clearTimeout(this.queryInterval);
		},
		data() {
			return {
				payType: [{
					type: '1',
					name: '企业支付'
				}, {
					type: '2',
					name: '支付宝'
				}, {
					type: '3',
					name: '转账'
				}, {
					type: '8',
					name: '商城充值卡'
				}, {
					type: '9',
					name: '商城训练卡'
				}, {
					type: '10',
					name: '科飞商城购买虚拟充值'
				}],
				allType: {
					'1': [{
						category: '0',
						name: '全部'
					}, {
						category: '1',
						name: '充值'
					}, {
						category: '2',
						name: '赠送'
					}, {
						category: '3',
						name: '扣除返还'
					}],
					'2': [{
						category: '0',
						name: '全部'
					}, {
						category: '1',
						name: '患者充值'
					}, {
						category: '2',
						name: '赠送'
					}, {
						category: '3',
						name: '被扣除'
					}]
				},

				loading: false,

				search_addr: {
					provinceCode: '',
					provinceName: '',
					cityCode: '',
					cityName: '',
					areaCode: '',
					areaName: ''
				},
				search_product: '',
				search_startTime: '',
				search_endTime: '',
				search_name: '',
				search_payType: '',
				search_type: '1',

				show_type: [],
				show_type_active: '0',

				currentPage: 1,
				total: 0,
				tableData: [],
			}
		},
		computed: {
			...mapState([
				'authInfo',
				'authProduct'
			])
		},
		methods: {
			/******************** @Ajax *************************/
			// 获取列表数据
			getList() {
				const that = this;
				that.loading = true;
				var requestData = {
					"endTime": that.search_endTime,
					"id": null,
					"limit": 10,
					"loginCategory": that.authInfo.ucategory,
					"loginEnterpriseId": that.authInfo.uenterpriseId,
					"loginUserId": that.authInfo.uid,
					"oneCategory": that.search_type,
					"pageNum": that.currentPage,
					"queryType": 3,
					"startTime": that.search_startTime,
					"twoCategory": that.show_type_active,
					"uareaName": that.search_addr.areaName,
					"uareaCode": that.search_addr.areaCode,
					"ucityName": that.search_addr.cityName,
					"ucityCode": that.search_addr.cityCode,
					"ucode": that.authInfo.ucode,
					"uenterpriseId": null,
					"uprovinceName": that.search_addr.provinceName,
					"uprovinceCode": that.search_addr.provinceCode,
					"uqueryEnterpriseName": that.search_name,
					"versionFlag": that.search_product,
					"payType": that.search_payType,
					"functionType": 1
				};
				Api.findFinanceCountConsumeRecord(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						var data = [];
						that.total = res.data.data.totalItems;
						res.data.data.data.forEach((v) => {
							data.push({
								code: that.search_type == 1 ?
									v.code :
									that.search_type == 2 ?
									v.operatorCode :
									'',
								name: that.search_type == 1 ?
									v.enterpriseName :
									that.search_type == 2 ?
									v.operator :
									'',
								num: v.utime || '',
								productId: v.uversionFlag || '',
								productName: '',
								payType: v.payType || '',
								payName: that.mapPayTypetoName(v.payType),
								actionCategory: v.ucategory || '',
								actionName: that.getActionNameByCategory(v.ucategory),
								operator: v.username || '/',
								operatorForm: v.usernameEnterpriseName || '/',
								remark: v.memo || '/',
								counts: v.counts || 0,
								creatTime: v.ucreateTs || ''
							});
						});
						that.tableData = data;
						that.mapProductIdtoName();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			/******************** @Events *************************/
			// 切换查询区域省份
			handleSearchProvinceSelect(data) {
				this.search_addr.provinceName = data.code ? data.value : '';
				this.search_addr.provinceCode = data.code ? data.code.slice(0, 3) : '';
			},
			// 切换查询区域城市
			handleSearchCitySelect(data) {
				this.search_addr.cityName = data.code ? data.value : '';
				this.search_addr.cityCode = data.code ? `${ data.code }000000` : '';
			},
			// 切换查询区域区域
			handleSearchAreaSelect(data) {
				this.search_addr.areaName = data.code ? data.value : '';
				this.search_addr.areaCode = data.code ? `${ data.code }000000` : '';
			},
			// 切换查询时间
			handleSearchStartTimeClick() {
				this.compareSearchTime();
			},
			// 切换查询时间
			handleSearchEndTimeClick() {
				this.compareSearchTime();
			},
			// 切换查询类型
			handleSearchTypeChange() {
				this.setShowType();
				this.resetData();
				this.getList();
			},
			// 所属医院匹配
			querySearchName(queryString, cb) {
				const that = this;
				that.queryInterval && clearTimeout(that.queryInterval);
				that.queryInterval = setTimeout(() => {
					var results = [];
					var requestData = {
						EnterpriseName: queryString
					};
					Api.findFirmsByName(requestData).then((res) => {
						if (res.data.success) {
							res.data.data.forEach(v => {
								results.push({
									value: v
								});
							});
							cb(results);
						} else {
							cb([]);
						}
					}, () => {
						cb([]);
					});
				}, 300);
			},
			// 点击查询
			handleSearchClick() {
				this.resetData();
				this.getList();
			},
			// 导出Excel数据
			exportExcel() {
				const that = this;
				that.loading = true;
				var requestData = {
					"endTime": that.search_endTime,
					"id": null,
					"limit": 10000,
					"loginCategory": that.authInfo.ucategory,
					"loginEnterpriseId": that.authInfo.uenterpriseId,
					"loginUserId": that.authInfo.uid,
					"oneCategory": that.search_type,
					"pageNum": 1,
					"queryType": 3,
					"startTime": that.search_startTime,
					"twoCategory": that.show_type_active,
					"uareaName": that.search_addr.areaName,
					"uareaCode": that.search_addr.areaCode,
					"ucityName": that.search_addr.cityName,
					"ucityCode": that.search_addr.cityCode,
					"ucode": that.authInfo.ucode,
					"uenterpriseId": null,
					"uprovinceName": that.search_addr.provinceName,
					"uprovinceCode": that.search_addr.provinceCode,
					"uqueryEnterpriseName": that.search_name,
					"versionFlag": that.search_product,
					"payType": that.search_payType,
					"functionType": 2
				};
				Api.findFinanceCountConsumeRecord(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						var str =
							`序号,${ that.search_type == 1 ? '编码' : '账号' },${ that.search_type == 1 ? '医院名称' : '被操作人' },次数,产品,${ that.search_type == 1 && that.authInfo.ucategory == 1 ? '购买次数,' : '' }${ that.search_type == 1 ? '支付类型,' : '' }操作类型,操作人,操作机构,${ that.search_type == 1 ? '备注,' : '' }创建时间,\n`;
						res.data.data.data.forEach((v, index) => {
							str += `${ index+1 },`
							// str += v.code || '';
							str += v.operatorCode || '';
							str += '\t,';
							str += that.search_type == 1 ?
								v.enterpriseName :
								that.search_type == 2 ?
								v.operator :
								'';
							str += ',';
							str += v.utime || '';
							str += ',';
							for (var i = 0; i < that.authProduct.length; i++) {
								if (v.uversionFlag == that.authProduct[i].id)
									str += that.authProduct[i].name;
							}
							str += ',';
							(that.search_type == 1 && that.authInfo.ucategory == 1) && (str += v.counts);
							(that.search_type == 1 && that.authInfo.ucategory == 1) && (str += ',');
							that.search_type == 1 && (str += that.mapPayTypetoName(v.payType));
							that.search_type == 1 && (str += ',');
							str += that.getActionNameByCategory(v.ucategory);
							str += ',';
							str += v.username || '/';
							str += ',';
							str += v.usernameEnterpriseName || '/';
							str += ',';
							that.search_type == 1 && (str += v.memo || '/');
							that.search_type == 1 && (str += ',');
							str += v.ucreateTs || '';
							str += '\t,';
							str += '\n';
						});
						BaseMethods.outputExcel(str, '医院对账');
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击显示类型
			handleShowTypeClick(category) {
				if (this.show_type_active != category) {
					this.show_type_active = category;
					this.resetData();
					this.getList();
				}
			},
			// 切换页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getList();
				}
			},
			/******************** @Function *************************/
			// 设置显示类型
			setShowType() {
				this.show_type = this.allType[this.search_type];
				this.show_type_active = this.show_type[0].category;
			},
			// 重置需要重置的数据
			resetData() {
				this.search_type == 2 && (this.search_payType = '');
				this.currentPage = 1;
			},
			// 根据操作类型转换操作名称
			getActionNameByCategory(category) {
				var list = this.allType[this.search_type],
					result = '';
				for (var i = 0; i < list.length; i++) {
					if (list[i].category == category)
						result = list[i].name;
				}
				return result;
			},
			// 比较开始时间和结束时间
			compareSearchTime() {
				if (this.search_startTime && this.search_endTime) {
					var startTime = new Date(this.search_startTime).getTime(),
						endTime = new Date(this.search_endTime).getTime();
					if (endTime < startTime) {
						this.search_endTime = '';
						this.$message({
							message: '结束时间不能小于开始时间',
							type: 'warning'
						});
					}
				}
			},
			// 获取支付类型名称
			mapPayTypetoName(type) {
				var str = '';
				this.payType.forEach(v => {
					v.type == type && (str = v.name);
				});
				return str;
			},
			// 把产品id转为名称
			mapProductIdtoName() {
				var arr = [...this.tableData];
				if (this.authProduct.length) {
					arr.forEach((v) => {
						for (var i = 0; i < this.authProduct.length; i++) {
							if (v.productId == this.authProduct[i].id)
								v.productName = this.authProduct[i].name;
						}
					});
				}
				this.tableData = arr;
			}
		}
	}
</script>

<style scoped>
</style>